
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insureshield/terms",
      function () {
        return require("private-next-pages/insureshield/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insureshield/terms"])
      });
    }
  